export const T = {
  en_GB: {
    productsTitle: "Products",
    addProduct: "Add Product",
    noProducts: 'No products added yet. Click "Add Product" to get started.',
    product: "Product",
    isin: "ISIN",
    wrapperTypes: "Wrapper Types",
    weight: "Weight",
    minBuy: "Min. buy",
    actions: "Actions",
    total: "Total",
    mustTotal100: "Must total 100%",
    minimumInvestment: (amount: string, product: string) =>
      `Minimum investment: ${amount} — the smallest amount where every product with a minimum buy reaches it at its weight (driven by ${product}).`,
    editDescription: "Update the weight allocation for this product.",
    cancel: "Cancel",
    deleteProductTitle: "Delete Product",
    deleteProductDescription:
      "Are you sure you want to delete this product? This action cannot be undone.",
    delete: "Delete",
    failedToDelete: "Failed to delete product",
  },
  nb_NO: {
    productsTitle: "Produkter",
    addProduct: "Legg til produkt",
    noProducts: 'Ingen produkter lagt til ennå. Klikk "Legg til produkt" for å komme i gang.',
    product: "Produkt",
    isin: "ISIN",
    wrapperTypes: "Innpakningstyper",
    weight: "Vekting",
    minBuy: "Min. kjøp",
    actions: "Handlinger",
    total: "Totalt",
    mustTotal100: "Må totalt bli 100%",
    minimumInvestment: (amount: string, product: string) =>
      `Minste investering: ${amount} — det minste beløpet der hvert produkt med minimumskjøp når det med sin vekting (bestemt av ${product}).`,
    editDescription: "Oppdater vektingsallokeringen for dette produktet.",
    cancel: "Avbryt",
    deleteProductTitle: "Slett produkt",
    deleteProductDescription:
      "Er du sikker på at du vil slette dette produktet? Denne handlingen kan ikke angres.",
    delete: "Slett",
    failedToDelete: "Kunne ikke slette produkt",
  },
} as const;
